import axios from 'axios';
import { constructSearchObj } from '../../utils/utils';
import {
  CLEAR_EQUIPMENT_HOLDING_PROFILE,
  DELETE_HOLDING_PROFILES,
  EQUIPMENT_PRODUCT_PROFILES_FETCH,
  EQUIPMENT_SERIAL_NUMBERS_FETCH,
  EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS,
  EQUIPMENTS_CLEAR_ENTITIES,
  EQUIPMENTS_CLEAR_ENTITY,
  EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES,
  EQUIPMENTS_CLEAR_PAGINATION_INFO,
  EQUIPMENTS_CREATE_EQUIPMENT,
  EQUIPMENTS_EDIT_EQUIPMENT,
  EQUIPMENTS_FETCH_EQUIPMENT,
  EQUIPMENTS_FETCH_EQUIPMENTS,
  EQUIPMENTS_FETCH_EQUIPMENTS_PIECES,
  EQUIPMENTS_FETCH_HOLDING_PROFILE,
  EQUIPMENTS_FETCH_HOLDING_PROFILES,
  EQUIPMENTS_FETCH_MODELS,
  EQUIPMENTS_FETCH_SUPPLIERS,
  EQUIPMENTS_SET_COUNTRIES,
  EQUIPMENTS_SET_EQUIPMENT_TO_EDIT,
  EQUIPMENTS_SET_PAGE,
  EQUIPMENTS_SET_REGIONS,
  EQUIPMENTS_SET_ROWS_PER_PAGE,
  EQUIPMENTS_SET_SEARCH_OBJECT,
  EQUIPMENTS_TRANSLATIONS,
  EQUIPMENTS_TRANSLATIONS_UPDATE,
} from '../action-types/equipments-types';
import { axiosAction } from '../../utils/axiosAction';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_EQUIPMENTS}`;
const HOLDING_PROFILES_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_HOLDING_PROFILES}`;
const ENDPOINT_EQUIPMENTS_TRANSLATIONS = `${process.env.REACT_APP_ENDPOINT_EQUIPMENT_TRANSLATION_ENDPOINT}`;
const SERIAL_NUMBERS_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_EQUIPMENT_SPECIFIC_ENDPOINT}/serial-numbers`;

const getEntitiesPiecesRequest = () => ({
  type: EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.REQUEST,
});

export const clearEntitiesPieces = () => ({
  type: EQUIPMENTS_CLEAR_EQUIPMENTS_PIECES,
});

export const clearHoldingProfile = () => ({
  type: CLEAR_EQUIPMENT_HOLDING_PROFILE,
});
const getEntitiesSuccessPieces = payload => ({
  type: EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.SUCCESS,
  payload,
});

export const setSearchObject = payload => ({
  type: EQUIPMENTS_SET_SEARCH_OBJECT,
  payload,
});

export const setRegions = payload => ({
  type: EQUIPMENTS_SET_REGIONS,
  payload,
});

export const setCountries = payload => ({
  type: EQUIPMENTS_SET_COUNTRIES,
  payload,
});

export const clearEntityToEdit = () => ({
  type: EQUIPMENTS_CLEAR_ENTITY,
});

const getEntitiesPiecesRejected = () => ({
  type: EQUIPMENTS_FETCH_EQUIPMENTS_PIECES.REJECTED,
});

const getModelsRequest = () => ({
  type: EQUIPMENTS_FETCH_MODELS.REQUEST,
});

const getModelsSuccess = payload => ({
  type: EQUIPMENTS_FETCH_MODELS.SUCCESS,
  payload,
});

const getModelsRejected = () => ({
  type: EQUIPMENTS_FETCH_MODELS.REJECTED,
});
const createEquipmentRequest = () => ({
  type: EQUIPMENTS_CREATE_EQUIPMENT.REQUEST,
});

const createEquipmentSuccess = payload => ({
  type: EQUIPMENTS_CREATE_EQUIPMENT.SUCCESS,
  payload,
});

const createEquipmentRejected = () => ({
  type: EQUIPMENTS_CREATE_EQUIPMENT.REJECTED,
});

export const clearEntities = () => ({
  type: EQUIPMENTS_CLEAR_ENTITIES,
});

export const setRowsPerPage = payload => ({
  type: EQUIPMENTS_SET_ROWS_PER_PAGE,
  payload,
});

const editEquipmentRequest = () => ({
  type: EQUIPMENTS_EDIT_EQUIPMENT.REQUEST,
});

const editEquipmentSuccess = payload => ({
  type: EQUIPMENTS_EDIT_EQUIPMENT.SUCCESS,
  payload,
});
const editEquipmentRejected = () => ({
  type: EQUIPMENTS_EDIT_EQUIPMENT.REJECTED,
});

const assignUnassignEquipmentsRequest = () => ({
  type: EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS.REQUEST,
});

const assignUnassignEquipmentsSuccess = payload => ({
  type: EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS.SUCCESS,
  payload,
});
const assignUnassignEquipmentsRejected = () => ({
  type: EQUIPMENTS_ASSIGN_UNASSIGN_EQUIPMENT_TO_RESTAURANTS.REJECTED,
});

export const setPage = payload => ({
  type: EQUIPMENTS_SET_PAGE,
  payload,
});

export const clearPaginationInfo = () => ({
  type: EQUIPMENTS_CLEAR_PAGINATION_INFO,
});

export const getHoldingProfilesEquipmentAssigned =
  idEquipment => async dispatch => {
    const endpoint = `${ENDPOINT_EQUIPMENTS_TRANSLATIONS}${idEquipment}/holding-profiles`;
    return axiosAction.get(
      endpoint,
      EQUIPMENT_PRODUCT_PROFILES_FETCH,
      dispatch,
    );
  };

export const getEntities = searchObj => async dispatch => {
  const newSearchObj = {
    ...searchObj,
    core: searchObj.core === 'All' ? '' : searchObj.core,
    franchise: searchObj.franchise === 'All' ? '' : searchObj.franchise,
    status: searchObj.status === 'All' ? '' : searchObj.status,
  };

  const endpoint = `${ENDPOINT}${constructSearchObj(newSearchObj)}`;
  return axiosAction.get(endpoint, EQUIPMENTS_FETCH_EQUIPMENTS, dispatch);
};

export const getEntitiesPieces = searchObj => async dispatch => {
  dispatch(getEntitiesPiecesRequest());
  try {
    const result: any = await axios(
      `${ENDPOINT}${constructSearchObj(searchObj)}`,
    );
    dispatch(
      getEntitiesSuccessPieces({
        data: result.data.equipments,
      }),
    );
    return result.data;
  } catch (error) {
    dispatch(getEntitiesPiecesRejected());
    return error.response;
  }
};

export const setEntityToEdit = payload => ({
  type: EQUIPMENTS_SET_EQUIPMENT_TO_EDIT,
  payload,
});

export const getEntity = id => async dispatch => {
  const endpoint = `${ENDPOINT}/${id}`;
  return axiosAction.get(endpoint, EQUIPMENTS_FETCH_EQUIPMENT, dispatch);
};

export const getSuppliers = brand => async dispatch => {
  const endpoint = `${ENDPOINT}/categories/${brand}`;
  return axiosAction.get(endpoint, EQUIPMENTS_FETCH_SUPPLIERS, dispatch);
};
export const getModels = brand => async dispatch => {
  dispatch(getModelsRequest());
  try {
    const result: any = await axios(`${ENDPOINT}/categories/${brand}`);
    dispatch(
      getModelsSuccess({
        data: result.data,
      }),
    );
    return result;
  } catch (error) {
    dispatch(getModelsRejected());
    return error.response;
  }
};

export const createNewEquipment = newEquipment => async dispatch => {
  dispatch(createEquipmentRequest());
  try {
    const result: any = await axios.post(ENDPOINT, newEquipment);
    dispatch(createEquipmentSuccess(result.data));
    return result;
  } catch (error) {
    dispatch(createEquipmentRejected());
    return error.response;
  }
};

export const editEquipment =
  (equipmentId, payload, method = 'put') =>
  async dispatch => {
    dispatch(editEquipmentRequest());
    try {
      const result: any = await axios[method](
        `${ENDPOINT}/${equipmentId}`,
        payload,
      );
      dispatch(editEquipmentSuccess(result.data));
      return result;
    } catch (error) {
      dispatch(editEquipmentRejected());
      return error.response;
    }
  };

export const assignUnassignEquipments =
  objToAssignUnassign => async dispatch => {
    const notNullsRestaurants = { ...objToAssignUnassign };
    notNullsRestaurants.restaurants = objToAssignUnassign.restaurants.filter(
      restaurant => restaurant !== 0,
    );
    dispatch(assignUnassignEquipmentsRequest());
    try {
      const result: any = await axios.post(
        `${ENDPOINT}/restaurants`,
        notNullsRestaurants,
      );
      dispatch(assignUnassignEquipmentsSuccess(notNullsRestaurants));
      return result;
    } catch (error) {
      dispatch(assignUnassignEquipmentsRejected());
      return error.response;
    }
  };
export const deleteEntitySuccess = payload => ({
  type: DELETE_HOLDING_PROFILES.SUCCESS,
  payload,
});

//get Holding profiles for equipment

export const getEquipmentHoldingProfiles =
  (params = {}) =>
  async dispatch => {
    const endpoint = `${HOLDING_PROFILES_ENDPOINT}${constructSearchObj(
      params,
    )}`;
    return axiosAction.get(
      endpoint,
      EQUIPMENTS_FETCH_HOLDING_PROFILES,
      dispatch,
    );
  };
export const getEquipmentHoldingProfile = (params, id) => async dispatch => {
  const endpoint = `${HOLDING_PROFILES_ENDPOINT}/${id}${constructSearchObj(
    params,
  )}`;
  return axiosAction.get(endpoint, EQUIPMENTS_FETCH_HOLDING_PROFILE, dispatch);
};
export const getEquipmentsTranslation =
  (equipmentId, brand) => async dispatch => {
    return axiosAction.get(
      `${ENDPOINT_EQUIPMENTS_TRANSLATIONS}${equipmentId}/translations?brand=${brand}`,
      EQUIPMENTS_TRANSLATIONS,
      dispatch,
    );
  };

export const UpdateEquipmentsTranslation =
  (equipmentId, brand, translationsValues) => async dispatch => {
    return axiosAction.put(
      `${ENDPOINT_EQUIPMENTS_TRANSLATIONS}${equipmentId}/translations?brand=${brand}`,
      EQUIPMENTS_TRANSLATIONS_UPDATE,
      dispatch,
      {
        translations: translationsValues,
      },
    );
  };

export const getEquipmentSerialNumbers = (params, meta?) => async dispatch => {
  return axiosAction.get(
    `${SERIAL_NUMBERS_ENDPOINT}${constructSearchObj(params)}`,
    EQUIPMENT_SERIAL_NUMBERS_FETCH,
    dispatch,
    { meta },
  );
};
